const WSSA_PROFILE_URL = "https://www.thewssa.com/sport-stackers/jonathan-scannell/1213/";
const WCA_PROFILE_URL = "https://www.worldcubeassociation.org/persons/2023SCAN02";
const YOUTUBE_URL = "https://www.youtube.com/c/JonScannell";

export { WSSA_PROFILE_URL, WCA_PROFILE_URL, YOUTUBE_URL }